import { IGamesState } from './model';

export const GamesInitState: IGamesState = {
  games: [],
  selectGame: null,
  openMenuStatus: [],
  allServiceConfig: [],
  envs: [],
  selectEnv: null,
  selectMenuId: 0,
  myFavoriteList: [],
  serviceFavoriteTotal: [],
  allEnvList: [],
};
